import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: 'v7nxkytw',
  dataset: 'production',
  apiVersion: '2024-01-01',
  useCdn: true, // Use CDN for faster reads (no token needed for public data)
});
